module.exports = __webpack_public_path__ + "static/media/sol-mobile.9ed68820.png";